/**
 * Figma: https://www.figma.com/design/XwMQV9iBJ1Ec4sOzWMEZcK/-Dev--Customer-Hub-2.3-%E2%80%93-Phase-1?node-id=2226-106325&m=dev
 */

import OrderStateCard from '../cards/OrderStateCard'

import type {
  OrderStateCard as OrderStateCardData,
  OrderStateCta,
  TimelineLabels,
} from '../types'

interface OrderStateProps {
  cards: OrderStateCardData[]
  /** Translated timeline captions — one set for every card in the section. */
  timelineLabels?: TimelineLabels
  onCtaClick?: (card: OrderStateCardData, cta: OrderStateCta) => void
}

export default function OrderState({
  cards,
  timelineLabels,
  onCtaClick,
}: OrderStateProps) {
  if (cards.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-20" data-testid="order-state">
      {cards.map((card, index) => (
        // orderId repeats across cards of the same order, so it cannot key
        // the list on its own.
        <OrderStateCard
          key={`${card.orderId}-${index}`}
          card={card}
          timelineLabels={timelineLabels}
          onCtaClick={onCtaClick}
        />
      ))}
    </div>
  )
}
